export default __webpack_public_path__ + "static/media/Awards.c8f1cecc.svg";